<span>&nbsp;    
    <fa-icon [icon]="faChevronUp" *ngIf="sortAscending"></fa-icon>
    <fa-icon [icon]="faChevronDown" *ngIf="!sortAscending"></fa-icon>    
</span>